"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTotalCentsToDollars = exports.formatTotalDollars = void 0;
const React = require("react");
const react_1 = require("react");
const styles = require("./StripePaymentOptions.styles.scss");
const StripePaymentOptionsProvider_1 = require("./StripePaymentOptionsProvider");
const StripePromiseProvider_1 = require("../StripePromiseProvider");
const StripePaymentRequestProvider_1 = require("./StripePaymentRequestProvider");
const TextButton_1 = require("../BasicComponents/TextButton");
const FlatButton_1 = require("../BasicComponents/FlatButton");
const SinglePaymentOption_1 = require("../BasicComponents/SinglePaymentOption");
const ActivePaymentOption_1 = require("../BasicComponents/ActivePaymentOption");
const useStripeSetupIntent_1 = require("../Hooks/useStripeSetupIntent");
const Loader_1 = require("../../../atoms/Loader");
const FlatCard_1 = require("../BasicComponents/FlatCard");
const StripeSetupSecretProvider_1 = require("../Hooks/StripeSetupSecretProvider");
exports.default = () => {
    const { currentStatus, loadingState } = (0, StripePaymentOptionsProvider_1.useStripePaymentOptions)();
    return (React.createElement("div", { className: styles.mainContainer },
        React.createElement("h3", { className: styles.paymentMethodTitle }, "PAYMENT METHODS"),
        React.createElement(FlatCard_1.default, { style: {
                minWidth: 300,
                minHeight: 350,
                display: "flex",
                flexDirection: "column"
            } },
            loadingState == "Loading" && React.createElement(Loader_1.Loader, { size: "md" }),
            currentStatus == "OVERVIEW" && React.createElement(OverviewCheckoutComponent, null),
            currentStatus == "SELECT_PAYMENT_METHODS" && (React.createElement(SelectPaymentMethodsComponent, null)),
            currentStatus == "ADD_PAYMENT_METHOD" && (React.createElement(SetupActivePaymentComponent, null)))));
};
const OverviewCheckoutComponent = () => {
    var _a, _b;
    const [errorText, setErrorText] = (0, react_1.useState)("");
    const stripe = (0, StripePromiseProvider_1.useStripePromise)();
    const { currentPaymentMethod, paymentMethods, handleChangePayment, loadingState } = (0, StripePaymentOptionsProvider_1.useStripePaymentOptions)();
    const { confirmPayment, overview, confirming } = (0, StripePaymentRequestProvider_1.useStripePaymentRequest)();
    const selectedOption = paymentMethods.find(x => x.id == currentPaymentMethod);
    const handleConfirmPayment = async () => {
        setErrorText("");
        if (!currentPaymentMethod) {
            setErrorText("No payment method selected!");
            return;
        }
        let confirmResult = await confirmPayment({
            usePaymentRequest: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.isPaymentRequest,
            paymentMethodId: currentPaymentMethod
        });
        if (confirmResult === null || confirmResult === void 0 ? void 0 : confirmResult.Error) {
            setErrorText(confirmResult.Error);
        }
    };
    const currentCost = (0, exports.formatTotalCentsToDollars)((_a = overview === null || overview === void 0 ? void 0 : overview.totalPriceCents) !== null && _a !== void 0 ? _a : 0);
    return (React.createElement(React.Fragment, null,
        React.createElement("h4", { className: styles.walletText }, "Selected Payment Method"),
        React.createElement("div", { style: { flex: 1 } },
            selectedOption && (React.createElement(ActivePaymentOption_1.default, { onSelect: handleChangePayment, icon: selectedOption.icon, name: (_b = selectedOption.name) !== null && _b !== void 0 ? _b : "", description: selectedOption.description })),
            loadingState == "Loaded" && !selectedOption && (React.createElement(ActivePaymentOption_1.default, { onSelect: handleChangePayment, icon: "none", name: "", description: "" }))),
        React.createElement("div", { style: {
                color: "red",
                display: "flex",
                justifyContent: "center",
                padding: 5
            } }, errorText),
        React.createElement("div", { style: {
                display: "flex",
                border: "solid 2px #DADADA",
                borderRadius: 20,
                padding: 5
            } },
            React.createElement("div", { style: { flex: 1, display: "flex", justifyContent: "center" } },
                React.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "#8E8E93",
                        fontWeight: 700,
                        fontSize: 20
                    } }, currentCost)),
            React.createElement(FlatButton_1.default, { onClick: handleConfirmPayment, style: {
                    backgroundColor: "#63a555",
                    padding: 0,
                    margin: 0,
                    flex: 2
                }, className: styles.placeOrderButton },
                React.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "row",
                        fontWeight: "bold"
                    } },
                    React.createElement("div", { style: { flex: 1, padding: 20 } }, confirming ? (React.createElement("div", { style: { height: 10, transform: "translateY(-10px)" } },
                        React.createElement(Loader_1.Loader, { size: "md" }))) : ("PLACE ORDER")))))));
};
const SelectPaymentMethodsComponent = () => {
    var _a;
    const { addNewPaymentMethod } = (0, StripePaymentOptionsProvider_1.useStripePaymentOptions)();
    const { overview } = (0, StripePaymentRequestProvider_1.useStripePaymentRequest)();
    const currentCost = (0, exports.formatTotalCentsToDollars)((_a = overview === null || overview === void 0 ? void 0 : overview.totalPriceCents) !== null && _a !== void 0 ? _a : 0);
    return (React.createElement(React.Fragment, null,
        React.createElement("h4", { className: styles.walletText }, "YOUR WALLET"),
        React.createElement("div", { style: { flex: 1 } },
            React.createElement(PaymentMethodList, null),
            React.createElement("div", { className: styles.addNewCardButton },
                React.createElement(TextButton_1.default, { onClick: addNewPaymentMethod }, "+ Add new credit/debit card"))),
        React.createElement("div", { style: {
                display: "flex",
                border: "solid 2px #DADADA",
                borderRadius: 20,
                padding: 5
            } },
            React.createElement("div", { style: { flex: 1, display: "flex", justifyContent: "center" } },
                React.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "#8E8E93",
                        fontWeight: 700,
                        fontSize: 20
                    } }, currentCost)),
            React.createElement(FlatButton_1.default, { onClick: () => { }, disabled: true, style: {
                    backgroundColor: "#63a555",
                    padding: 0,
                    margin: 0,
                    flex: 2
                }, className: styles.placeOrderButton },
                React.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "row",
                        fontWeight: "bold"
                    } },
                    React.createElement("div", { style: { flex: 1, padding: 20, opacity: 0.6 } }, "PLACE ORDER"))))));
};
const SetupActivePaymentComponent = () => {
    return (React.createElement(StripeSetupSecretProvider_1.StripeSetupSecretProvider, null,
        React.createElement(AddPaymentMethodComponent, null)));
};
const AddPaymentMethodComponent = () => {
    const { addNewPaymentMethod, completeAddPayment } = (0, StripePaymentOptionsProvider_1.useStripePaymentOptions)();
    const [confirming, setConfirming] = (0, react_1.useState)(false);
    // const { addCardComponent, handleSubmit } = useStripeSetupIntent();
    const { checkoutComponent, confirmSetup } = (0, useStripeSetupIntent_1.default)({
        clientSecret: "seti_1PcYl8Rr9IclZiv7KwdGQ6TD_secret_QTVmE7qsLfrAK0XVapZJtD5Cz6wcRAs"
    });
    const handlePayment = async () => {
        if (!confirmSetup)
            return;
        try {
            setConfirming(true);
            const result = await confirmSetup();
            if (result.error) {
                setConfirming(false);
                return;
            }
        }
        catch (e) {
            console.log(e);
        }
        setConfirming(false);
        completeAddPayment();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { flex: 1 } }, checkoutComponent),
        React.createElement("div", { style: { display: "flex" } },
            React.createElement(FlatButton_1.default, { onClick: () => completeAddPayment(), style: {
                    backgroundColor: "#8a8a8a",
                    marginRight: 5,
                    padding: 20,
                    flex: 1
                }, className: styles.placeOrderButton }, "Cancel"),
            React.createElement(FlatButton_1.default, { onClick: () => handlePayment(), disabled: confirming, style: {
                    backgroundColor: "#63a555",
                    marginLeft: 5,
                    padding: 20,
                    flex: 1
                }, className: styles.placeOrderButton }, confirming ? (React.createElement("div", { style: { height: 10, transform: "translateY(-10px)" } },
                React.createElement(Loader_1.Loader, { size: "md" }))) : ("Next")))));
};
const PaymentMethodList = () => {
    const { paymentMethods, selectPaymentMethod, removePaymentMethod } = (0, StripePaymentOptionsProvider_1.useStripePaymentOptions)();
    const handleSelect = (method) => {
        selectPaymentMethod(method.id);
    };
    const handleDelete = (method) => {
        removePaymentMethod(method.id);
    };
    return (React.createElement(React.Fragment, null, paymentMethods.map(x => {
        var _a;
        return (React.createElement(SinglePaymentOption_1.default, { onSelect: () => handleSelect(x), icon: x.icon, name: (_a = x.name) !== null && _a !== void 0 ? _a : "", description: x.description, onDelete: x.isPaymentRequest ? undefined : () => handleDelete(x) }));
    })));
};
const formatTotalDollars = (dollars) => {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(dollars);
};
exports.formatTotalDollars = formatTotalDollars;
const formatTotalCentsToDollars = (cents) => {
    const dollars = cents / 100;
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(dollars);
};
exports.formatTotalCentsToDollars = formatTotalCentsToDollars;
//# sourceMappingURL=StripePaymentOptions.js.map